'use strict';

import ngResource from 'angular-resource';

function MissingListService ($resource) {
    return $resource(
        '/api/missing_list', {},
        { index : { method: 'GET', isArray: true } }
    )
}

export default angular.module('leptonApp.MissingListService', ['ngResource'])
    .factory('MissingListService', ['$resource', MissingListService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/missing_list/missing_list.service.js